import React from 'react';
import styled from 'styled-components';
import bg1 from '../../../../assets/images/bg_1.svg';
import bg2 from '../../../../assets/images/bg_2.svg';

const GradientBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 400px;
  z-index: 1;
  background: linear-gradient(135deg, #1FA2FF 0%, #12D8FA 50%, #A6FFCB 100%);
  pointer-events: none;
`;

const SvgOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 400px;
  z-index: 2; /* Поверх градиента */
  background-image: url(${bg1}); /* Только bg_1.svg для светлой темы */
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover; /* Растягиваем по всей ширине экрана */
  pointer-events: none;
  overflow: hidden;
`;

const BackgroundArt: React.FC = () => {
  return (
    <>
      <GradientBackground />
      <SvgOverlay />
    </>
  );
};

export default BackgroundArt;
